import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';

export const countryInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<StoreState>);
  const country = store.selectSignal(userSelectors.country)();
  if (country != null) {
    return next(
      req.clone({
        setHeaders: {
          'X-Country-Code': country,
        },
      })
    );
  }
  return next(req);
};
